import { render } from "./ProductGroupsCard.vue?vue&type=template&id=547334cc&scoped=true"
import script from "./ProductGroupsCard.vue?vue&type=script&lang=js"
export * from "./ProductGroupsCard.vue?vue&type=script&lang=js"

import "./ProductGroupsCard.vue?vue&type=style&index=0&id=547334cc&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547334cc"]])

export default __exports__